import React from "react";
import "./MainContainer.css";

interface Props {
  children: React.ReactNode;
}

const MainContainer = ({ children }: Props) => {
  return (
    <div className="bg-gray-100 flex justify-center">
      <div className="content-container flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default MainContainer;